ui-cms-header-service-area {
  display: none;

  .service-nav {
    @include reset-ul();
    font-size: $sd-fontSize-base;
    line-height: $sd-lineHeight-normal;
    display: inline-flex;
    align-items: center;

    sd-link::part(label) {
      text-decoration-line: none;
    }

    > li {
      @include reset-li();
      display: inline-block;

      // service & kontakt
      &.hasBreakpoint {
        display: none;
      }

      > sd-link,
      > a {
        display: block;
        padding: 13px 12px;
        height: auto;
        color: var(--component-link-color-text, var(--skin-color-primary, $ui-blue));

        &:hover {
          background-color: $sd-backgroundColor-neutral-200;
        }
      }
    }

    .dropdown {
      position: relative;

      &__content {
        width: 250px;
        padding: $sd-spacing-4 0;

        h2 {
          margin: 0 0 $sd-spacing-2 0;
          padding: 0 $sd-spacing-4;
        }

        li {
          margin-bottom: $sd-spacing-2;

          sd-link {
            display: block;
            font-weight: $sd-fontWeight-bold;
            padding: 0 $sd-spacing-4;
          }

          &:hover {
            background-color: $sd-backgroundColor-neutral-200;
          }
        }
      }
    }

    // search part
    .global-search-trigger button {
      cursor: pointer;
      padding: 13px 12px;
      background-color: transparent;
      border: none;

      &:hover {
        background-color: $sd-backgroundColor-neutral-200;
      }

      &::before {
        @include getIcon('\e645');
        font-size: 24px;
        color: $sd-textColor-primary-DEFAULT;
      }
    }

    .global-search {
      padding-right: 50px;
      width: 327px;
      display: none;
      position: relative;

      .close-search {
        cursor: pointer;
        position: absolute;
        right: 0;
        top: 0;

        &::before {
          @include getIcon('\e63f');
          font-size: 24px;
        }
      }
    }

    > li.global-search > a:hover {
      background-color: transparent;
    }

    &.search-active {
      li,
      sd-dropdown {
        display: none;
      }

      .global-search {
        display: inline-block;
      }
    }

    sd-icon {
      height: 1.5rem;
      width: 1.5rem;
      padding-right: $sd-spacing-1;
      box-sizing: content-box;
    }
  }

  .sr-only {
    @include sr-only;
  }

  /*** 1024 ***/
  @include breakpoint($desktop) {
    display: block;
  }
}
